import React from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Layouts
import Layout from "./layout/Layout";
import HomeLayout from "./layout/HomeLayout";
import "bootstrap/dist/css/bootstrap.min.css";
// Pages
import Logins from "./pages/Logins/Logins";
import Register1 from "./pages/Registers/Register1";
import Register3 from "./pages/Registers/Register3";
import Home from "./pages/main/Home";
import DataView from "./pages/main/DataView";
import Package from "./pages/main/Package";

import Notification from "./pages/main/Notification";
import ResetPassword from "./pages/main/ResetPassword";
import Error404 from "./pages/main/Error404";
import Setting from "./pages/setting/setting";
import AppRoute from "./pages/main/AppRoute";
import PDFLayout from "./layout/PDFLayout";
import LoginWithPhone from "./pages/Logins/LoginWithPhone";
import VideoPlayer from "./pages/main/VideoPlayer";
import OnlyPic from "./pages/main/OnlyPic";

function App() {
  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <RedirectIfAuthenticated redirectTo="/">
              <Layout>
                <Logins />
              </Layout>
            </RedirectIfAuthenticated>
          }
        />
        <Route
          path="/loginWithPhone"
          element={
            <RedirectIfAuthenticated redirectTo="/">
              <Layout>
                <LoginWithPhone />
              </Layout>
            </RedirectIfAuthenticated>
          }
        />
        <Route
          path="/register"
          element={
            <RedirectIfAuthenticated redirectTo="/">
              <Layout>
                <Register1 />
              </Layout>
            </RedirectIfAuthenticated>
          }
        />
        <Route
          path="/register3"
          element={
            <RedirectIfAuthenticated redirectTo="/">
              <Layout>
                <Register3 />
              </Layout>
            </RedirectIfAuthenticated>
          }
        />
        <Route
          path="/reset_password"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <ResetPassword />
              </HomeLayout>
            </RequireAuth>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/"
          index
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <Home />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/notification"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <Notification />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/package"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <Package />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/dataView"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <DataView />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/setting"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <Setting />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/appRoute"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <AppRoute />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/pdfLayout"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <PDFLayout />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/videoPlayer"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <VideoPlayer />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route
          path="/onlyPic"
          element={
            <RequireAuth redirectTo="/login">
              <HomeLayout>
                <OnlyPic />
              </HomeLayout>
            </RequireAuth>
          }
        />
        <Route path="/logout" element={<Logout />} />

        {/* Fallback Route */}
        <Route
          path="*"
          element={
            <HomeLayout>
              <Error404 />
            </HomeLayout>
          }
        />
      </Routes>

      {/* Toast Notifications */}
      <Toaster
        toastOptions={{
          success: {
            style: {
              background: "#04471c",
              direction: "rtl",
              color: "#ffff",
              maxWidth: "600px",
            },
          },
          error: {
            style: {
              direction: "rtl",
              background: "#c1121f",
              color: "#ffff",
              maxWidth: "600px",
            },
          },
        }}
      />
    </>
  );
}

function RequireAuth({ children, redirectTo }) {
  let isAuthenticated = localStorage.getItem("token");
  return isAuthenticated ? children : <Navigate to={redirectTo} replace />;
}

function RedirectIfAuthenticated({ children, redirectTo }) {
  let isAuthenticated = localStorage.getItem("token");
  return isAuthenticated ? <Navigate to={redirectTo} replace /> : children;
}

function Logout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear the auth token
    navigate("/login", { replace: true }); // Redirect to the login page
  };

  React.useEffect(() => {
    handleLogout();
  }, [navigate]);

  return null;
}

export default App;
